import React from 'react'
import '../../assets/theme/theme.less'
import { LayoutComponent as Layout } from '../../components'
import { Row, Col, Card, Button } from 'antd'
import { useLocation, Link } from 'react-router-dom'

const AccessRequest = () => {
    const location = useLocation()
    const attempted = location?.state?.from || location?.state?.path || ''

    return (
        <Layout width>
            <Row>
                <Col md={24}>
                    <h1 className="title page-title">Acesso necessário</h1>
                </Col>
                <Col md={24} className="mt-20">
                    <Card>
                        <p>Você não possui permissão para acessar esta página.</p>
                        {attempted && (
                            <p><b>URL solicitada:</b> {attempted}</p>
                        )}
                        <p>Para continuar, solicite acesso ao administrador do sistema.</p>
                        <div className="mt-15">
                            <Link to="/clientes/geral"><Button>Voltar</Button></Link>
                        </div>
                    </Card>
                </Col>
            </Row>
        </Layout>
    )
}

export default AccessRequest


